module.exports = __webpack_public_path__ + "shipment-icon.png?5ae04d209b55d98e4585160a537b3750";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shipment-icon.png
// module id = 214
// module chunks = 0